import get from 'lodash.get';
import { pageTypeConstants as pageTypes } from '../../../constants/pageTypeConstants';
import {
    FILTER_SEARCH,
    FILTER_REFINE_SEARCH,
} from '../../../finding/SbSharedRefineMenu/sbSharedRefineMenuConstants';
import paramsConfig from 'dibs-generate-uriref/src/paramsConfig.json';
import {
    getCategory,
    getCategories,
    categorySortOrder,
    getLowestCategory,
    getCategoryCode,
    getCategoryUrlLabel,
    getPageLevel,
    isCategory,
    CATEGORY_LEVEL_1,
    getCapitalizedFirstLetter,
} from '../../../utils/categoryHelpers';

const getAppliedCategoriesDisplayNames = (categories, topCategoryL1) => {
    return categorySortOrder
        .map(categoryName => {
            const category =
                categoryName === CATEGORY_LEVEL_1
                    ? topCategoryL1
                    : getCategoryUrlLabel(getCategory(categories, categoryName));
            return getCapitalizedFirstLetter(category);
        })
        .filter(Boolean);
};

const getPageSortLabel = sortValue => {
    const pageSortMap = {
        newest: 'newest',
        priceAsc: 'price-high',
        priceDesc: 'price-low',
    };

    return pageSortMap[sortValue];
};

const getFilterUrlLabel = (appliedFilters, filterName) => {
    const currentFilter = appliedFilters.filter(({ name }) => name === filterName);
    return get(currentFilter, '[0].values[0].urlLabel');
};

const getPageSubType = pageType => {
    const map = {
        origin: 'Place of Origin',
        dealer: 'Dealers',
    };
    let pageSubType;

    if (pageType) {
        pageSubType = map[pageType] || getCapitalizedFirstLetter(pageType);
    }

    return pageSubType;
};

const getGAKeyFromFilterName = (filterName, type = 'queryParam') => {
    let replacement;
    if (paramsConfig[filterName]) {
        replacement = paramsConfig[filterName][type];
    }
    return replacement || filterName;
};

const getPageviewData = ({
    pageType,
    appliedFilters = [],
    totalResults,
    pageNumber,
    optPageURL,
    sortValue,
    isModule,
    refineMenuFiltersMap,
    topCategoryL1,
}) => {
    const categories = getCategories(appliedFilters);
    const lowestCategory = getLowestCategory(categories);
    const appliedCategoriesDisplayNames = getAppliedCategoriesDisplayNames(
        categories,
        topCategoryL1
    );

    const pageLevel = getPageLevel(lowestCategory);
    const categoryCode = getCategoryCode(lowestCategory);

    // For L1s GA just wants the vertical label not the whole SEO name
    // i.e 'Jewelry' instead of 'Jewelry & Watches'
    // and 'Furniture' instead of '18th Century Furniture'
    const pageCategory = getCapitalizedFirstLetter(topCategoryL1);

    const pageSection = categories.map(getCategoryUrlLabel).join('/');
    const pageSort = getPageSortLabel(sortValue);
    const searchTerm =
        getFilterUrlLabel(appliedFilters, FILTER_SEARCH) ||
        getFilterUrlLabel(appliedFilters, FILTER_REFINE_SEARCH) ||
        '';
    const section = getFilterUrlLabel(appliedFilters, pageTypes.SECTION) || '';
    const pageSubType = getPageSubType(pageType);
    const contentModule = isModule ? 'y' : 'n';

    // object of all non-category applied filters keyed by name
    // ex. { color: ['red', 'silver'] }
    const appliedFilterSearchData = appliedFilters
        .filter(
            f => !isCategory(f) && !!refineMenuFiltersMap[f.name] && f.name !== FILTER_REFINE_SEARCH
        )
        .reduce((data, filter) => {
            const valueDisplayNames = filter.values.map(value =>
                getCapitalizedFirstLetter(value.urlLabel)
            );
            const filerName = getGAKeyFromFilterName(filter.name);
            data[filerName] = valueDisplayNames;

            return data;
        }, {});

    const appliedOptPageURL =
        !!getFilterUrlLabel(appliedFilters, FILTER_SEARCH) ||
        !!getFilterUrlLabel(appliedFilters, FILTER_REFINE_SEARCH)
            ? optPageURL
            : undefined;

    return {
        pageType: 'Results',
        pageSubType,
        categoryCode,
        pageCategory,
        pageLevel,
        pageSection,
        countOfItems: totalResults,
        contentModule,
        pageNumberViewed: pageNumber,
        pageSort,
        // eslint-disable-next-line camelcase
        opt_pageURL: appliedOptPageURL,
        viewMode: 'grid',
        searchData: {
            // eslint-disable-next-line camelcase
            applied_filters: appliedFilterSearchData,
            categories: appliedCategoriesDisplayNames,
            // eslint-disable-next-line camelcase
            search_term: searchTerm,
            section,
        },
    };
};

export { getPageviewData };
